import {
  useRegisteredComponent,
  type AgentSetupProgressProps,
} from '../registry/PluginComponentRegistry';

export type { AgentSetupProgressProps };

/**
 * Agent setup progress component.
 *
 * This component requires host-specific infrastructure (API client, elapsed
 * time hooks, stream bubble container, etc.) and cannot be rendered in
 * isolation. The web host must provide the real implementation via
 * `PluginComponentProvider`.
 *
 * @throws Error if the component is not registered
 */
export function AgentSetupProgress(props: AgentSetupProgressProps) {
  const RegisteredComponent = useRegisteredComponent('AgentSetupProgress');
  return <RegisteredComponent {...props} />;
}
